import { Injectable } from '@angular/core';
import { SupabaseClient } from '@supabase/supabase-js';
import { BehaviorSubject } from 'rxjs';
import { StateService } from './state.service';
import { SupabaseService } from './supabase.service';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  client: SupabaseClient;
  tenantProfile: any;
  logoUrl: string;

  public tenantLogo = new BehaviorSubject<string>('');
  public allowedTenants = new BehaviorSubject<any[]>([]);
  public activeTenant = new BehaviorSubject<any>({});

  constructor(
    private supabase: SupabaseService,
    private state: StateService,
    private titleService: Title
  ) {
    this.client = this.supabase.supabaseClient;
  }

  async getTenant() {
    const { data } = await this.client
      .from('tenants')
      .select('*,bureaus(airtableKey, name, airtableBase)');

    if (data.length > 0) {
      /** if the state.tenants === [] and activeTenant is null, set the initial state */

      //get value from localStorage, key: tenants
      const currentState = this.state.getStateOnce();

      if (
        currentState.tenants.length === 0 &&
        currentState.activeTenant === null
      ) {
        this.state.setInitialTenantState({
          tenants: data,
          activeTenant: data[0],
        });
      }
      console.log(currentState.tenants === data);
      if (currentState.tenants !== data) {
        console.log('tenants data has changed');
        this.state.updateTenants(data);
      }

      if (currentState.activeTenant) {
        this.titleService.setTitle(currentState.activeTenant.name);
        this.changeColor(currentState.activeTenant.primaryColor);
        this.changeSecondaryColor(currentState.activeTenant.secondaryColor);
      } else {
        this.changeColor(data[0].primaryColor);
        this.changeSecondaryColor(currentState.activeTenant.secondaryColor);
      }

      return currentState.activeTenant !== null
        ? currentState.activeTenant
        : data[0];
    }
  }

  /** Change the App's primary color */
  changeColor(color: string) {
    document.documentElement.style.setProperty('--ion-color-primary', color);
    // Keep the rgb triplet in sync so rgba(var(--ion-color-primary-rgb), a)
    // tints (and Ionic's own focus/hover states) reflect the practice colour.
    const rgb = this.toRgbTriplet(color);
    if (rgb) {
      document.documentElement.style.setProperty(
        '--ion-color-primary-rgb',
        rgb
      );
    }
  }

  /** "#5abb4e" | "#abc" -> "90, 187, 78" (null if unparseable) */
  private toRgbTriplet(hex: string): string | null {
    if (!hex) {
      return null;
    }
    let h = hex.trim().replace('#', '');
    if (h.length === 3) {
      h = h
        .split('')
        .map((c) => c + c)
        .join('');
    }
    if (h.length !== 6) {
      return null;
    }
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    if ([r, g, b].some((n) => isNaN(n))) {
      return null;
    }
    return `${r}, ${g}, ${b}`;
  }

  changeSecondaryColor(color: string) {
    document.documentElement.style.setProperty('--ion-color-secondary', color);
  }

  getAllowedTenants() {
    return this.allowedTenants.asObservable();
  }

  getActiveTenant() {
    return this.activeTenant.asObservable();
  }

  getTenantLogo() {
    return this.tenantLogo.asObservable();
  }

  async getTestTenant() {}

  async updateTenant(newData: {}, tenantId: string) {
    const { data } = await this.client
      .from('tenants')
      .update(newData)
      .eq('id', tenantId)
      .select('*');

    if (data) {
      return data;
    }
  }
  getSession() {
    return this.supabase.getSession();
  }
}
